import { classNames } from "../../../lib/class-names";
import Icon from "../icon/icon";

import "./box-icon.scss";

const sizeConversion = {
  small: { box: "2rem", icon: "1rem" },
  medium: { box: "3rem", icon: "1.5rem" },
  big: { box: "4rem", icon: "2rem" },
};

type BoxIconPropsT = {
  icon: string | number;
  size: "small" | "medium" | "big";
  type:
    | "primary"
    | "primary-disabled"
    | "secondary"
    | "tertiary"
    | "primary-rounded"
    | "primary-disabled-rounded"
    | "secondary-rounded"
    | "tertiary-rounded";
  clickable?: boolean;
};

const BoxIcon = ({ icon, size, type, clickable }: BoxIconPropsT) => {
  const boxSize = sizeConversion[size].box;
  const iconSize = sizeConversion[size].icon;

  const isData = typeof icon === "number";

  const boxIconClasses = classNames({
    "box-icon": true,
    "box-icon--primary": type === "primary" || type === "primary-rounded",
    "box-icon--primary-disabled":
      type === "primary-disabled" || type === "primary-disabled-rounded",
    "box-icon--secondary": type === "secondary" || type === "secondary-rounded",
    "box-icon--tertiary": type === "tertiary" || type === "tertiary-rounded",
    "box-icon--rounded":
      type === "primary-rounded" ||
      type === "secondary-rounded" ||
      type === "tertiary-rounded",
    "box-icon__clickable": !!clickable,
    "box-icon__clickable--primary": !!clickable && type === "primary",
    "box-icon__clickable--secondary": !!clickable && type === "secondary",
  });

  const iconClasses = classNames({
    "box-icon__icon": true,
    "box-icon__icon--primary": type === "primary" || type === "primary-rounded",
    "box-icon__icon--primary-disabled":
      type === "primary-disabled" || type === "primary-disabled-rounded",
    "box-icon__icon--secondary":
      type === "secondary" || type === "secondary-rounded",
    "box-icon__icon--tertiary":
      type === "tertiary" || type === "tertiary-rounded",
  });

  return (
    <div className={boxIconClasses} style={{ width: boxSize, height: boxSize }}>
      {isData ? (
        <span className="box-icon__text-icon">{icon}</span>
      ) : (
        <Icon name={icon} size={iconSize} className={iconClasses} />
      )}
    </div>
  );
};

export default BoxIcon;
